import {
  GoogleMap,
  InfoWindow,
  useLoadScript,
  MarkerF,
  MarkerClusterer,
} from "@react-google-maps/api";
import { useEffect, useState } from "react";
import "./GMap.css";
import customMarker from "../../../../Assets/icons8-round.svg"; // Import the MarkerClusterer library
import DropDown from "../../../../Components/DropDown/DropDown";
import { genericFetchData } from "../../../../Services/Service";
import { API_KEY } from "../../../../Utils/AppConstance";

const GMap = () => {
  const mapOptions = {
    styles: [
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      // Hide labels and geometry for specific features
      {
        featureType: "administrative.country",
        elementType: "geometry",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "country",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
    ],
  };
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: API_KEY,
  });
  const [center, setCenter] = useState({ lat: 20.5937, lng: 78.9629 });
  const [selectedIndex, setselectedIndex] = useState(0);
  const [platform, setPlatform] = useState({ name: "Mykare", id: 1 });

  const [locations, setLocations] = useState([]);

  const platforms = [
    { name: "Mykare", id: 1 },
    { name: "Karetrip", id: 2 },
  ];
  const type = ["Hospitals", "Doctors"];

  const [selectedLocation, setSelectedLocation] = useState(null);

  const getLocation = async () => {
    const type = selectedIndex == 0 ? "HOSPITAL" : "DOCTOR";
    const response = await genericFetchData(
      `/data/geoTagging?dataType=${type}&platformId=${platform.id}`,
      "GET"
    );
    if (response.status === 200) {
      const responseData = await response.json();
      const data = responseData.geoTagList.map((val) => ({
        id: val.id,
        name: val.name,
        lat: val.latitude ? Number(val.latitude) : null,
        lng: val.longitude ? Number(val.longitude) : null,
        address: val.address,
      }));
      setLocations(data);
    }
  };

  useEffect(() => {
    // Close the InfoWindow when a different location is selected
    setSelectedLocation(null);
    getLocation();
  }, [selectedIndex, platform]);

  return (
    <div className="App">
      {!isLoaded ? (
        <h1>Loading...</h1>
      ) : (
        <div style={{ height: "98vh" }}>
          <GoogleMap
            key={new Date().getTime()}
            clickableIcons={false}
            mapContainerClassName="map-container"
            center={center}
            zoom={5}
            options={mapOptions}
          >
            <div
              style={{
                position: "absolute",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                top: 60,
                left: 10,
              }}
            >
              <div
                style={{
                  padding: 5,
                  backgroundColor: "white",
                  borderRadius: 5,
                  height: 80,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {type.map((val, i) => (
                  <div
                    onClick={() => {
                      setselectedIndex(i);
                    }}
                    key={i}
                    style={{
                      padding: 5,
                      backgroundColor: selectedIndex == i ? "black" : "white",
                      borderRadius: 5,
                      color: selectedIndex == i ? "white" : "black",
                    }}
                  >
                    {val}
                  </div>
                ))}
              </div>
              <DropDown
                style={{ marginRight: 20 }}
                bgColor="white"
                viewHeight={"40px"}
                viewWidth={"150px"}
                borderRadius={"5px"}
                value={platform}
                data={platforms}
                handleSelected={(e, value) => {
                  setPlatform(value);
                }}
              />
            </div>
            <MarkerClusterer averageCenter enableRetinaIcons gridSize={60}>
              {(clusterer) =>
                locations.map((location, i) => (
                  <MarkerF
                    title={location.name}
                    label={location.name}
                    key={i}
                    position={{ lat: location.lat, lng: location.lng }}
                    onClick={() => {
                      setCenter({ lat: location.lat, lng: location.lng });
                      setSelectedLocation(location);
                    }}
                    clusterer={clusterer}
                  />
                ))
              }
            </MarkerClusterer>

            {selectedLocation ? (
              <InfoWindow
                position={{
                  lat: selectedLocation.lat,
                  lng: selectedLocation.lng,
                }}
                onCloseClick={() => setSelectedLocation(null)}
              >
                <div>
                  <h3>{selectedLocation.name}</h3>
                  <p>Rating: {selectedLocation.rating}</p>
                  <p>Address: {selectedLocation.address}</p>
                </div>
              </InfoWindow>
            ) : null}
          </GoogleMap>
        </div>
      )}
    </div>
  );
};

export default GMap;
